(function () {
	'use strict';

    angular.module("imApp").factory("docArticlePorusService", ['$ihttp', function ($ihttp) {
		let service = {
            listReadActivities: function (parms) {
                return $ihttp.post({
                    method: 1379,
                    parameters: parms || {}
                });
            }
		};

		return service;
	}]);
})();
